import browser from '@/kits//browser';
import { hybrid } from 'hybrid-sdk-common';
import { inApp, isInHomeWork, isHarmony, isAndroid, isInKd } from '@/kits//system';

export const getXiaomiSchema = async (): Promise<string | undefined> => {
  const domain = location.origin;
  // const fromAppId = isInHomeWork ? 'homework' : isInKd ? 'scancode' : 'browser';
  let fromAppId = '';
  if (isInHomeWork) {
    fromAppId = 'homework';
  } else if (isInKd) {
    fromAppId = 'scancode';
  } else if (inApp) {
    fromAppId = 'college';
  } else {
    fromAppId = 'browser';
  }

  const { errNo, data } = await fetch(`${domain}/dxapp/mixins/mideeplink?appId=wakeup&fromAppId=${fromAppId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => res.json());
  if (errNo == 0) {
    return data.deeplink;
  }
};

export interface AppLinksOptions {
  appStore?: string;
  downloadLink?: string;
  yybLink?: string;
  nativeLinkIos?: string;
  nativeLinkAndroid?: string;
  universalLink?: string;
  harmonyLink?: string;
  knowInstalled?: number; // 0 未安装 1 已安装
  isTip?: boolean | number; // 是否在端内展示提示弹框
}
const ua = navigator.userAgent;
let iosV = 0;
const match = ua.match(/OS (\d+)_/i);
if (match) {
  iosV = parseInt(match[1]);
}
const OS = {
  homework: /homework/i.test(ua),
  android: /android/i.test(ua),
  ios: /iPad|iPhone/i.test(ua),
  iosVersion: iosV,
  weixin: /MicroMessenger/i.test(ua),
  weibo: /(weibo).*weibo__(\d.)+/i.test(ua),
  baidu: /(baiduboxapp)\/([\d.]+)/i.test(ua),
  QQ: /qq\/([\d.]+)/i.test(ua),
  QQBrowser: /(qqbrowser)\/([\d.]+)/i.test(ua),
  Qzone: /qzone\/.*_qz_([\d.]+)/i.test(ua)
};

const defaultOptions: Required<AppLinksOptions> = {
  appStore: 'https://apps.apple.com/cn/app/id1553402284',
  downloadLink: '',
  yybLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.suda.yzune.wakeupschedule',
  nativeLinkIos: 'wakeupschedule://com.suda.yzune.wakeupschedule',
  nativeLinkAndroid: 'wakeupschedule://main',
  universalLink: '',
  harmonyLink: 'https://appgallery.huawei.com/app/C100084997',
  knowInstalled: -1,
  isTip: true
};

const packageAddress = 'com.suda.yzune.wakeupschedule';
let marketUrl = '';

(async () => {
  if (isInHomeWork || inApp || isInKd) {
    let { brand } = await hybrid('core_commonData');
    brand = brand.toLowerCase();
    const marketObj = {
      async xiaomi() {
        const deeplink = await getXiaomiSchema();
        marketUrl = deeplink || `mimarket://details/detailmini?id=${packageAddress}`;
      },
      async redmi() {
        const deeplink = await getXiaomiSchema();
        marketUrl = deeplink || `mimarket://details/detailmini?id=${packageAddress}`;
      },
      huawei() {
        marketUrl = `https://appgallery.huawei.com/app/C100084997`;
      },
      honor() {
        marketUrl = `appmarket://details?id=${packageAddress}`;
      },
      oppo() {
        marketUrl = `oppomarket://details?packagename=${packageAddress}`;
      },
      realme() {
        marketUrl = `oppomarket://details?packagename=${packageAddress}`;
      },
      vivo() {
        marketUrl = `vivomarket://details?id=${packageAddress}`;
      }
    };
    marketObj[brand as keyof typeof marketObj] && (await marketObj[brand as keyof typeof marketObj]());
  } else {
    const marketObj = {
      xiaomi: {
        reg: /\(.*Android.*(MI|Mi|Redmi).*\)/i,
        newReg: /(MI|Mi|Readmi[\s/]|MiuiBrowser)/i,
        marketUrl: `mimarket://details?id=${packageAddress}`
      },
      huawei: {
        reg: /\(.*Android.*(HUAWEI|HONOR).*\)/i,
        newReg: /(HUAWEI|HONOR[\s/])/i,
        marketUrl: `appmarket://details?id=${packageAddress}`
      },
      oppo: {
        reg: /\(.*Android.*(oppo|OPPO|realme).*\)/i,
        newReg: /(oppo|OPPO|realme[\s/])/i,
        marketUrl: `oppomarket://details?packagename=${packageAddress}`
      },
      vivo: {
        reg: /\(.*Android.*(vivo|VIVO).*\)/i,
        newReg: /(vivo|VIVO[\s/])/i,
        marketUrl: `vivomarket://details?id=${packageAddress}`
      }
    };
    for (const key in marketObj) {
      if (marketObj[key as keyof typeof marketObj].reg.test(`${navigator.userAgent}`)) {
        marketUrl = marketObj[key as keyof typeof marketObj].marketUrl;
        break;
      }
    }
    if (marketUrl === '') {
      for (const key in marketObj) {
        if (marketObj[key as keyof typeof marketObj].newReg.test(`${navigator.userAgent}`)) {
          marketUrl = marketObj[key as keyof typeof marketObj].marketUrl;
          break;
        }
      }
    }
  }
})();

class wakeUpAppLinks {
  private options = defaultOptions;
  private hidden: 'hidden' | 'webkitHidden' | undefined = undefined;
  private visibilityChange: 'visibilitychange' | 'webkitvisibilitychange' | undefined = undefined;
  static tagA: HTMLAnchorElement | null = null;
  static iframe: HTMLIFrameElement | null = null;

  public getSupportedProperty(): void {
    if (typeof document.hidden !== 'undefined') {
      this.hidden = 'hidden';
      this.visibilityChange = 'visibilitychange';
      // @ts-ignore xxx
    } else if (typeof document.webkitHidden !== 'undefined') {
      this.hidden = 'webkitHidden';
      this.visibilityChange = 'webkitvisibilitychange';
    }
  }

  constructor(newOpt?: AppLinksOptions) {
    if (newOpt) {
      this.options = this.defaults<AppLinksOptions>(newOpt, this.options);
    }
  }

  public eq(value: unknown, other: unknown): boolean {
    return value === other || (value !== value && other !== other);
  }
  public defaults<T>(object: T, ...sources: T[]): Required<T> {
    object = Object(object);
    sources.forEach(source => {
      if (source != null) {
        source = Object(source);
        for (const key in source) {
          const value = object[key as keyof T];

          if (
            value === undefined ||
            // @ts-ignore key type error
            (this.eq(value, Object.prototype[key]) && !Object.prototype.hasOwnProperty.call(object, key))
          ) {
            object[key as keyof T] = source[key as keyof T];
          }
        }
      }
    });
    return object as Required<T>;
  }

  // 判断应用市场
  private judgeApplicationMarket(): string {
    return marketUrl;
  }

  private preventFailInvoke = false;
  private invoke(type: string, uri: string): void {
    let done = function (resolve: any) {
      resolve(uri);
    };
    if (this.options.isTip) {
      if (OS.homework) {
        const self = this;
        this.preventFailInvoke = true;
        if (OS.android) {
          done = function (resolve): void {
            const resolveFunc = function (res: any) {
              if (res.result == 1) {
                resolve(uri);
                self.preventFailInvoke = false;
                self.fallToFbUrl(self.options);
              }
            };
            hybrid(
              'zybQuasiRecruit',
              {
                message: '即将打开“WakeUp”APP',
                type: 1
              },
              resolveFunc
            );
          };
        } else {
          done = function (resolve): void {
            const resolveFunc = function (res: any) {
              if (res.res == 2) {
                resolve(uri);
                self.preventFailInvoke = false;
                self.fallToIosAppStore(self.options);
              }
            };
            hybrid(
              'showDialog',
              {
                title: '即将打开“WakeUp”APP',
                description: '',
                negativeText: '取消',
                positiveText: '确定'
              },
              resolveFunc
            );
          };
        }
      }
    }
    switch (type) {
      case 'a':
        done(this.invokeByTagA);
        break;
      case 'l':
        done(this.invokeByLocation);
        break;
      case 'i':
        done(this.invokeByIFrame);
        break;
    }
  }

  public invokeByLocation(uri: string): void {
    window!.top!.location.href = uri;
  }
  // 使用a标签跳转
  public invokeByTagA(uri: string): void {
    if (!wakeUpAppLinks.tagA) {
      const tagA = document.createElement('a');
      tagA.style.display = 'none';
      document.body.appendChild(tagA);
      wakeUpAppLinks.tagA = tagA;
    }
    wakeUpAppLinks.tagA.setAttribute('href', uri);
    wakeUpAppLinks.tagA.click();
  }

  // 使用iframe标签跳转
  public invokeByIFrame(uri: string): void {
    if (!wakeUpAppLinks.iframe) {
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
      document.body.appendChild(iframe);
      wakeUpAppLinks.iframe = iframe;
    }
    wakeUpAppLinks.iframe.src = uri;
  }

  public checkOpen(failure: () => void): void {
    if (this.preventFailInvoke) return;
    const timeout = 1500;
    const { hidden, visibilityChange } = this;
    const timer = setTimeout(() => {
      // @ts-ignore xxx
      const pageHidden = !!(hidden && document[hidden]);
      if (!pageHidden) failure();
    }, timeout);

    if (typeof visibilityChange !== 'undefined') {
      document.addEventListener(
        visibilityChange,
        () => {
          clearTimeout(timer);
        },
        { once: true }
      );
    } else {
      window.addEventListener(
        'pagehide',
        () => {
          clearTimeout(timer);
        },
        { once: true }
      );
    }
  }
  // 失败了=>跳转到App Store
  public fallToIosAppStore(options: Required<AppLinksOptions>): void {
    this.checkOpen(() => {
      this.invokeByTagA(options.appStore);
    });
  }

  // 失败了=>跳转到去下载apk
  public fallToFbUrl(options: Required<AppLinksOptions>): void {
    this.checkOpen(() => {
      // 安卓的QQ和QQBrowser环境跳转不到应用商店
      if (OS.QQ || OS.QQBrowser) {
        this.invokeByLocation(options.downloadLink);
      } else {
        const link = this.judgeApplicationMarket() || options.downloadLink;
        this.invokeByLocation(link);
      }
    });
  }

  // 失败了=> 使用failure()函数
  public fallToCustomCb(failure: () => void): void {
    this.checkOpen(() => {
      failure();
    });
  }

  public active(optionsOrUrl?: AppLinksOptions, failure?: () => void): void {
    this.getSupportedProperty();
    if (optionsOrUrl) {
      this.options = this.defaults<AppLinksOptions>(optionsOrUrl, this.options);
    }

    if (typeof window !== 'object') {
      throw new Error('this method requires a browser environment');
    }

    const { appStore, nativeLinkIos, downloadLink, nativeLinkAndroid, universalLink, knowInstalled } = this.options;
    const { fallToIosAppStore, fallToFbUrl, fallToCustomCb } = this;

    let checkOpenFall: (() => void) | undefined = undefined;

    if (knowInstalled == 1) {
      if (OS.ios) {
        this.invoke('i', nativeLinkIos);
        // 已安装情况下，不考虑打开失败case
        // checkOpenFall = fallToIosAppStore.bind(this, this.options);
      } else {
        if (isHarmony && isInHomeWork) {
          hybrid('openApp', {
            bundleName: 'fun.wakeup.schedule',
            abilityName: 'EntryAbility',
            type: 3 // 打开
          });
          return;
        } else {
          this.invoke('i', nativeLinkAndroid);
          // 已安装情况下，不考虑打开失败case
          // checkOpenFall = fallToFbUrl.bind(this, this.options);
        }
      }
    } else if (knowInstalled == 0) {
      if (OS.ios) {
        this.invoke('a', appStore);
        return;
      } else {
        if (isHarmony && isInHomeWork) {
          hybrid('openApp', {
            bundleName: 'fun.wakeup.schedule',
            abilityName: 'EntryAbility',
            type: 2 // 下载
          });
          return;
        } else {
          const link = this.judgeApplicationMarket() || downloadLink;
          this.invoke('l', link);
          return;
        }
      }
    } else {
      if (isHarmony && isInHomeWork) {
        hybrid('openApp', {
          bundleName: 'fun.wakeup.schedule',
          abilityName: 'EntryAbility',
          type: 2 // 下载
        });
        return;
      }
      // ios 微信自 7.0.5 版本放开了 UniversalLink 的限制
      // ios 微博禁止了 universalLink
      // 微信环境不能使用scheme协议跳转
      else if (isHarmony && !isAndroid) {
        this.invoke('l', this.options.harmonyLink);
      } else if (OS.ios) {
        if ((OS.weixin && browser.semverCompare(browser.getWeChatVersion(), '7.0.5') === -1) || OS.weibo) {
          this.invoke('l', appStore);
        } else if (OS.iosVersion < 9) {
          this.invoke('i', nativeLinkIos);
          checkOpenFall = fallToIosAppStore.bind(this, this.options);
        } else if (OS.QQ || OS.QQBrowser || OS.Qzone) {
          this.invoke('a', nativeLinkIos);
          checkOpenFall = fallToIosAppStore.bind(this, this.options);
        } else {
          if (universalLink) {
            this.invoke('l', universalLink);
          } else {
            this.invoke('l', appStore);
          }
        }
      } else if (browser.isOriginalChrome()) {
        // scheme 在 andriod chrome 25+ 版本上iframe无法正常拉起
        this.invoke('l', nativeLinkAndroid);
        checkOpenFall = fallToFbUrl.bind(this, this.options);
      } else if (OS.weixin) {
        alert('请点击右上角，用浏览器打开');
        return;
      } else if (OS.baidu || OS.weibo || OS.Qzone) {
        this.invoke('l', downloadLink);
      } else {
        this.invoke('i', nativeLinkAndroid);
        checkOpenFall = fallToFbUrl.bind(this, this.options);
      }
    }

    if (typeof failure !== 'undefined') {
      fallToCustomCb(failure);
      return;
    }

    if (!checkOpenFall) return;
    checkOpenFall();
  }
}
export default wakeUpAppLinks;
